import type { SocialPlatform } from "@/lib/types";

// Minimal inline outline icons -- avoids pulling in an icon package for six glyphs. `size-5
// stroke-current` on every path means each one just inherits color/sizing from its wrapper.
const PATHS: Record<SocialPlatform, string> = {
  instagram:
    "M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm5 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm4.5-1.5h.01",
  whatsapp:
    "M6 18l1.2-3.5A7.5 7.5 0 1 1 12 19.5a7.4 7.4 0 0 1-3.5-.9L6 18Zm4.2-7.7c.2 1.6 1.9 3.3 3.5 3.5.6.1 1-.3.9-.9l-.2-.9a.6.6 0 0 0-.5-.4l-1-.2-.7.7c-.6-.3-1.3-1-1.6-1.6l.7-.7-.2-1a.6.6 0 0 0-.4-.5l-.9-.2c-.6-.1-1 .3-.9.9",
  facebook: "M14 21v-7h2.4l.4-3H14V9c0-.9.2-1.5 1.6-1.5H17V5c-.3 0-1.2-.1-2.3-.1-2.3 0-3.7 1.4-3.7 4v2H9v3h2v7h3Z",
  youtube:
    "M4 8.5A2.5 2.5 0 0 1 6.5 6h11A2.5 2.5 0 0 1 20 8.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 15.5v-7Zm6.5 1v5l4.5-2.5-4.5-2.5Z",
  linkedin:
    "M4.5 4.5h3v3h-3v-3ZM5 9h2v11H5V9Zm5 0h2v1.6c.6-1 1.6-1.8 3.2-1.8 2.4 0 3.8 1.6 3.8 4.7V20h-2v-5.9c0-1.6-.6-2.5-1.9-2.5-1.4 0-2.1 1-2.1 2.5V20h-3V9Z",
  other: "M10.5 13.5 15 9m-6 8-2.5 2.5a3.5 3.5 0 1 1-5-5L4 12m10-8 2.5-2.5a3.5 3.5 0 1 1 5 5L19 8",
};

export default function SocialIcon({ platform, className }: { platform: SocialPlatform; className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className ?? "size-5"}
      aria-hidden
    >
      <path d={PATHS[platform] ?? PATHS.other} />
    </svg>
  );
}
